import { SvgIcon } from '@mui/material';

const BeveragesIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M8.434 14.9h-5.45l-.5-10.3h6.45z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.834 1h2.65l1.2 12.2m-2.95-3.45h5.95m2.451-2.55a3.85 3.85 0 0 1 0 7.7"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.084 2.2v.2a2.95 2.95 0 0 1-2.95 2.95v-.2a2.95 2.95 0 0 1 2.95-2.95Z"
          stroke="currentColor"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default BeveragesIcon;
